export enum PROJECTS_FILTER_KEYS {
  DUE_DATE = "due_date",
}

export enum PROJECTS_FILTERS {
  CONTEXT = "context[organization]",
  LOCATION_ID = "filter[location.id]",
  ORGANIZATION_ID = "filter[organization_id]",
  USERS_ID = "filter[users.id]",
}
